module.exports = __webpack_public_path__ + "img/ptpp.64574702.webp";